const content = {
  banner: {
    header: 'Cześć, mam na imię Aleks',
    subheader: 'Kocham psy, las i pisanie.<br />Uczę jak zamieniać myśli w słowa.'
  },
  articles: [
    {
      text: 'Jak zacząć prowadzić dziennik i po tygodniu nie zrezygnować?',
      link: 'https://aleksandramakulska.pl/jak-zaczac-prowadzic-dziennik/',
      overlay: '#6fc3df'
    },
    {
      text: 'Klub Otwartej Szuflady - klub pisarski online',
      link: 'https://aleksandramakulska.pl/produkt/klub-otwartej-szuflady/',
      overlay: '#8d82c4'
    },
    {
      text: 'Pisz Odważnie - 30-dniowy trening pisarski',
      link: 'https://aleksandramakulska.pl/produkt/pisz-odwaznie-30-dniowy-trening-pisania-online/',
      overlay: '#ec8d81'
    },
    {
      text: 'Kurs copwritingu dla początkujących',
      link: 'https://aleksandramakulska.pl/produkt/copywriting-dla-poczatkujacych-kurs-online/',
      overlay: '#87c5a4'
    },
    {
      text: 'Krótkie myśli',
      link: 'https://aleksandramakulska.pl/blog/',
      overlay: '#e7b788'
    },
    {
      text: 'Listy z Szuflady - wyjątkowy newsletter',
      link: 'https://aleksandramakulska.pl/listy-z-szuflady/',
      overlay: '#8ea9e8'
    },
  ],
  footer: {
    email: 'aleks.makulska@gmail.com'
  }
};

export default content;